import React from "react"
import PropTypes from "prop-types"
import { Form, Input, Select } from "antd"
import UserImage from "../../../../UserImage"

const Option = Select.Option

const SectionOneManduUser = (props) => {
  const { currentData, isNew } = props
  const { getFieldDecorator } = props.form
  return (
    <div className="ManduUserDrawerComponent-FormNew">
      <div>
        <div
          className="ManduUserDrawerComponent-FormNew-section"
          style={{ display: isNew ? "block" : "none" }}>
          <h4>Tipo de usuario</h4>
          <div>
            <Select
              style={{ width: "100%" }}
              placeholder="Seleccionar tipo"
              onChange={(e) => props.setStateForm("id_role", e)}
              value={currentData.id_role}>
              <Option value={3}>Superadministrador</Option>
              <Option value={4}>Administrador</Option>
            </Select>
          </div>
        </div>
        <div className="ManduUserDrawerComponent-FormNew-section">
          <h4>Correo electrónico</h4>
          <div>
            <Form.Item>
              {getFieldDecorator("email", {
                initialValue: currentData.email,
                rules: [
                  { type: "email", message: formLabel.es.email_valid },
                  {
                    required: true,
                    message: formLabelMessage("es", "required"),
                  },
                ],
              })(
                <Input
                  onChange={(e) => props.setStateForm("email", e.target.value)}
                  placeholder="email@ejemplo.com"
                />
              )}
            </Form.Item>
          </div>
        </div>
      </div>
      <div style={{ padding: 20 }}>
        <UserImage
          url={currentData.picture_profile}
          setFile={(f) => props.setStateForm("picture_profile", f)}
        />
      </div>
    </div>
  )
}

SectionOneManduUser.propTypes = {
  isNew: PropTypes.bool,
  currentData: PropTypes.object,
  form: PropTypes.object,
  setStateForm: PropTypes.func,
}

export default SectionOneManduUser
